import apiClient from './client'
import type { Assistant, CreateAssistantRequest, UpdateAssistantRequest } from '@/types'

export const assistantsApi = {
  getByOrganizationId: async (orgId: string): Promise<Assistant[]> => {
    const { data } = await apiClient.get(`/organizations/${orgId}/assistants`)
    return data
  },

  getById: async (id: string): Promise<Assistant> => {
    const { data } = await apiClient.get(`/assistants/${id}`)
    return data
  },

  create: async (orgId: string, req: CreateAssistantRequest): Promise<Assistant> => {
    const { data } = await apiClient.post(`/organizations/${orgId}/assistants`, req)
    return data
  },

  update: async (id: string, req: UpdateAssistantRequest): Promise<Assistant> => {
    const { data } = await apiClient.put(`/assistants/${id}`, req)
    return data
  },

  activate: async (id: string): Promise<void> => {
    await apiClient.post(`/assistants/${id}/activate`)
  },

  deactivate: async (id: string): Promise<void> => {
    await apiClient.post(`/assistants/${id}/deactivate`)
  },

  delete: async (id: string): Promise<void> => {
    await apiClient.delete(`/assistants/${id}`)
  },
}
